import React from 'react';
import PermissionService from '@services/permission.service';
import { coreTranslations } from 'translations';
import isMobileAppView from 'common/utility/isMobileAppView'

import {
    AuditTrialImage,
    CallListImage,
    ReportsImage,
    UsageImage,
    AnalyticsImage,
    SuppressedAlertImage
} from '@components/GlobalSearch/Images';

const permissionService = new PermissionService();

const usesNextGenSendingEngine = permissionService.permissions.usesNextGenSendingEngine();
const canManageAssetDataStore = permissionService.permissions.canManageAssetDataStore();

const isOpV3Org = (canManageAssetDataStore || usesNextGenSendingEngine);

export const tilesConfig = [
    {
        title: coreTranslations.ng_core_reports,
        description: coreTranslations.ng_core_reportsDescription,
        path: '/ad-hoc',
        icon: <ReportsImage color="primary" />,
        visible: access => access.canViewAdHocReports()
    },
    {
        title: coreTranslations.ng_core_auditTrail,
        description: coreTranslations.ng_core_auditTrailDescription,
        icon: <AuditTrialImage color="primary" />,
        path: isOpV3Org
            ? '/audit-trail'
            : {
                  redirectTo: '/prepareOrgAdminMain.do',
                  redirectBaseUrl: 'MIR3ApiBaseUrl'
              },
        visible: access => access.canViewAuditTrail() && !isMobileAppView()
    },
    {
        title: coreTranslations.ng_core_usage,
        description: coreTranslations.ng_core_usageDescription,
        path: '/usage-reports',
        icon: <UsageImage color="primary" />,
        visible: access => access.canViewUsage()
    },
    {
        title: coreTranslations.ng_core_callList,
        description: coreTranslations.ng_core_callListDescription,
        path: '/call-list',
        icon: <CallListImage color="primary" />,
        visible: access => access.canViewReporting()
    },
    {
        title: coreTranslations.ng_core_customReports,
        description: coreTranslations.ng_core_customReportsDescriptions,
        path: {
            redirectTo: '/res/customReports/show-reports.html?resetPicklist=picklist',
            redirectBaseUrl: 'MIR3ApiBaseUrl'
        },
        icon: <CallListImage color="primary" />,
        visible: access => access.canViewCustomReports() && !isMobileAppView()
    },
    {
        title: coreTranslations.ng_core_billing_usage,
        description: coreTranslations.ng_core_billingUsageDescription,
        path: '/billing-usage-reports',
        icon: <UsageImage color="primary" />,
        visible: access => access.canViewBillingUsage()
    },
    {
        title: coreTranslations.ng_core_people_over_time,
        description: coreTranslations.ng_core_people_over_timeDescription,
        path: '/people-over-time',
        icon: <UsageImage color="primary" />,
        visible: access => access.canViewPeopleOverTime()
    },
    {
        title: coreTranslations.ng_core_historical_reporting,
        description: coreTranslations.ng_core_historical_reporting_description,
        path: '/eventreporting',
        visible: access => permissionService.permissions.canViewHistoricalReporting()
    },
    {
        title: coreTranslations.ng_core_BIReporting,
        description: coreTranslations.ng_core_BIReportingDescription,
        path: '/dashboards',
        icon: <AnalyticsImage color="primary" />,
        visible: access => permissionService.permissions.canViewBIReporting()
    },
    {
        title: coreTranslations.ng_core_suppressReporting,
        description: coreTranslations.ng_core_suppressReportingDescription,
        path: '/suppressed-alert',
        icon: <SuppressedAlertImage color="primary" />,
        visible: access =>
            access.canViewSuppressedAlert() && !isMobileAppView() && access.usesNextGenSendingEngine()
    }
];
